exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dt-bold .vdatetime-input {\n  font-weight: bold;\n}\n.label-icon {\n  top: -1px;\n  position: relative;\n}\n.dtime-icon {\n  position: absolute;\n  margin-top: 15px;\n  margin-left: 18px;\n}\n.dt-scroller {\n  overflow: hidden;\n}\n.vdatetime-input {\n  width: 100%;\n  background-color: transparent;\n  border: none;\n  outline: none;\n  padding-left: 31px;\n}\n@media (max-width: 768px) {\n.vdatetime-input {\n    padding-left: 0;\n    width: 168px;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-50d972c4","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/standard/input/InputDateTime.vue
// module id = 9kEE
// module chunks = 53